
import { Base } from '../base-component';

import { AnalyticsService } from '../../services/analytics.service';
import { TooltipsService } from '../../services/tooltips.service';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import './product-offering-exchange.component.scss';

import * as $ from 'jquery';
import * as _ from 'lodash';

declare var jsonData;

export class ProductOfferingExchange extends Base {

	endpoint: string;
	productKey: string;
	filterJson: any;
	productJson: any;
	comparison: any;
	comparable: boolean;
	productContainer: JQuery<HTMLElement>;
	compareCard: JQuery<HTMLElement>;
	removeAll: JQuery<HTMLElement>;
	filterItem: JQuery<HTMLElement>;
	producttype: string;

	currencies: any;
	currencyContainer: Element;
	currencySelector: Element[];
	currencyStorage: any;

	eligibilityStorage: any;

	containerEligibilityMessage: any;

	constructor(element: Element, analyticsService: AnalyticsService) {

		super(element);

	}

	init() {

		let storage: any = localStorage.getItem('comparison');
		let storageCurrency: any = localStorage.getItem('currency');
		let storageEligibility: any = localStorage.getItem('eligibility');

		this.endpoint = this.element.getAttribute('data-endpoint');
		this.productKey = this.element.getAttribute('data-productkey');
		this.productContainer = $('.product-card-wrapper');
		this.currencyContainer = this.element.querySelector('.product-offering-exchange__currencies--items');
		this.removeAll = $('.js-remove-all');

		this.producttype = this.element.getAttribute('data-producttype');
		if (this.producttype) {
			this.producttype = this.producttype.toLowerCase();
		}

		if (!storage) {

			storage = {};
			storage[this.productKey] = [];

			localStorage.setItem('comparison', JSON.stringify(storage));

		} else {

			storage = JSON.parse(storage);

			if (!storage[this.productKey]) {

				storage[this.productKey] = [];
				localStorage.setItem('comparison', JSON.stringify(storage));

			}

		}

		if(!storageCurrency){

			storageCurrency = "";			

			localStorage.setItem('currency', JSON.stringify(storageCurrency));

		}else{

			storageCurrency = JSON.parse(storageCurrency);

			if (!storageCurrency) {

				storageCurrency = "";
				localStorage.setItem('currency', JSON.stringify(storageCurrency));

			}

		}

		if(!storageEligibility){

			storageEligibility = {};
			localStorage.setItem('eligibility', JSON.stringify(storageEligibility));

		}else{

			storageEligibility = JSON.parse(storageEligibility);

		}

		this.comparison = storage;
		this.currencyStorage = storageCurrency;
		this.eligibilityStorage = storageEligibility;

		this.getProducts();

	}

	bindEvents() {

		$(document).on('click', '.js-remove-compare', (e) => {

			let productId = $(e.currentTarget).data('id');

			if (this.comparison[this.productKey].find((item) => { return item == productId })) {

				let index = this.comparison[this.productKey].indexOf(productId);

				if (index >= 0) {

					this.comparison[this.productKey].splice(index, 1);

					localStorage.setItem('comparison', JSON.stringify(this.comparison));

					if (this.comparison[this.productKey].length >= 2) {

						$('.js-compare-button').removeClass('button--disabled');

					} else {

						$('.js-compare-button').addClass('button--disabled');

					}

					$(`.form__control--checkbox input`).removeAttr('disabled');
					$(`.product-card[data-id='${productId}'] .product-card__outer`).removeClass("gradient-border");
					$(`.form__control--checkbox[data-id='${productId}'] input`).prop('checked', false);

					$(`.product-offering-exchange__compare-chip[data-id='${productId}']`).addClass('product-offering-exchange__compare-chip--hide');
					setTimeout(() => {

						$(`.product-offering-exchange__compare-chip[data-id='${productId}']`).remove();

						if (!this.productComparisonCheck()) {

							$('.product-offering-exchange__compare').removeClass('product-offering-exchange__compare--active');

						}

					}, 300);

				}

			}

		});

		this.removeAll.click((e) => {
			e.preventDefault();

			$(`.product-card .product-card__outer`).removeClass("gradient-border");
			$(`.form__control--checkbox input`).removeAttr('disabled');
			$(`.form__control--checkbox input`).prop('checked', false);
			$(`.product-offering-exchange__compare-chip`).addClass('product-offering-exchange__compare-chip--hide');

			setTimeout(() => {
				$(`.product-offering-exchange__compare-chip`).remove();
				// $(`.product-offering-exchange__compare-chip-padder`).remove();

				this.comparison[this.productKey] = [];
				localStorage.setItem('comparison', JSON.stringify(this.comparison));

				$('.product-offering-exchange__compare').removeClass('product-offering-exchange__compare--active');
				$('.js-compare-button').removeClass('button--disabled');

			}, 300);

		});

		$(document).on('click', '.product-filter__item', (e) => {
			let filter = $(e.currentTarget).data('filter');
			this.filterProducts(filter);
		});

		window.addEventListener('resize', this.debounce(() => {

			this.normalizeCardHeight();

		}, 50, false));

		this.currencySelector.map((item) => item.addEventListener('click', (event) => {
			this.currencySelector.forEach(element => {
				element.classList.remove('product-offering-exchange__currencies--item__active');
			});
			this.currencyClick(event);
		}));

		$(document).on('click', '.js-recheck-eligibility', (e) => {
			let element = e.target;
			this.recheckEligibility(element);
		});

		$(document).on('click', 'div.product-offering-exchange__button[data-buttonclass=Apply]', (e) => {
			let element: any;
			if(e.currentTarget){
				element = e.currentTarget;
			}else{
				element = e.target;
			}
			let getAnchor = element.querySelector('a');
			let getLeadId = getAnchor.getAttribute('data-leadid');
			let getProductName = getAnchor.getAttribute('data-productname');
			let getClosestParent = element.closest('.product-card__buttons');
			let getEligibilityMessage = getClosestParent.querySelector('.product-offering-exchange__eligibility-message');
			this.actionApplyNow(getLeadId, getProductName, getEligibilityMessage);
		});

	}

	animate() {

	}

	getProducts() {

		let parseData = jsonData;

		this.currencies = parseData.currencies;
		this.filterJson = parseData.filters;
		this.productJson = parseData.products;

		this.comparable = _.some(this.productJson, (product) => {
			return product.comparable;
		});

		this.renderFilters();

		let docfragment = document.createDocumentFragment();

		let iCount = 1;
		this.productJson.forEach(card => {

			docfragment.appendChild(this.renderProduct(card, iCount));

		});

		this.productContainer[0].appendChild(docfragment);

		TooltipsService.initTooltips();

		this.normalizeCardHeight();

		this.compareCard = $('.js-compare');

		this.compareCard.click((e) => this.compareClick(e));

		//this.comparison = localStorage.getItem('comparison');

		if (this.comparison) {

			//this.comparison = JSON.parse(this.comparison);

			this.comparison[this.productKey].forEach(id => {

				$(`.product-card[data-id='${id}'] .product-card__outer`).addClass("gradient-border");

				$(`.form__control--checkbox[data-id='${id}'] input`).prop('checked', 'checked');

			});

			if (this.comparison[this.productKey].length >= 3) {

				$(`.form__control--checkbox input`).prop('disabled', 'disabled');

				this.comparison[this.productKey].forEach(id => {

					$(`.form__control--checkbox[data-id='${id}'] input`).removeAttr('disabled');

				});

			}

			if (this.comparison[this.productKey].length > 0) {

				let hasComparedProducts = false;

				if (this.productComparisonCheck()) {
					$('.product-offering-exchange__compare').addClass('product-offering-exchange__compare--active');

					this.comparison[this.productKey].forEach(id => {

						this.renderComparisonChips(id);

					});

					// $('.product-offering-exchange__compare-chip-padder').remove();
					// $('.product-offering-exchange__compare-chip-wrapper').append("<span class='product-offering-exchange__compare-chip-padder'>&nbsp;</span>");

				}


			}

			if (this.comparison[this.productKey].length >= 2) {

				$('.js-compare-button').removeClass('button--disabled');

			} else {

				$('.js-compare-button').addClass('button--disabled');

			}

		}

		this.renderCurrencyFilters(this.currencies);

	}

	normalizeCardHeight() {

		if ($(window).width() < 951) {

			$('.product-card__content').css('min-height', `initial`);
			$('.product-card__content > p').css('min-height', `initial`);
			$('.product-card__terms').css('min-height', `initial`);

		} else {

			let highestContent = 0;
			$('.product-card__content').each((index, el) => {

				let contentHeight = $(el).outerHeight();

				if (highestContent < contentHeight) {
					highestContent = contentHeight;
				}

			});

			$('.product-card__content').css('min-height', `${highestContent}px`);

			let highestParagragh = 0;
			$('.product-card__content > p').each((index, el) => {

				let paragraphHeight = $(el).height();

				if (highestParagragh < paragraphHeight) {
					highestParagragh = paragraphHeight;
				}

			});

			$('.product-card__content > p').css('min-height', `${highestParagragh}px`);

			let highestTerms = 0;
			$('.product-card__terms').each((index, el) => {

				let termHeight = $(el).height();

				if (highestTerms < termHeight) {
					highestTerms = termHeight;
				}

			});

			$('.product-card__terms').css('min-height', `${highestTerms}px`);

		}

		// let wrapper = this.element.querySelector('.product-card-wrapper');
		// wrapper.setAttribute('style',`min-height: ${wrapper.clientHeight}px`);

	}

	compareClick(e) {

		let productId = $(e.currentTarget).parent().data('id');


		if (!this.comparison[this.productKey]) {

			this.comparison[this.productKey].push(productId);

			localStorage.setItem('comparison', JSON.stringify(this.comparison));

			this.renderComparisonChips(productId);

			$('.product-offering-exchange__compare').addClass('product-offering-exchange__compare--active');
			$('.js-compare-button').addClass('button--disabled');

		} else {

			if (this.comparison[this.productKey].find((item) => { return item == productId })) {

				let index = this.comparison[this.productKey].indexOf(productId);

				if (index >= 0) {

					this.comparison[this.productKey].splice(index, 1);

					localStorage.setItem('comparison', JSON.stringify(this.comparison));

					$(`.form__control--checkbox input`).removeAttr('disabled');
					$(`.product-offering-exchange__compare-chip[data-id='${productId}']`).remove();
					$(`.product-offering-exchange__compare-chip[data-id='${productId}']`).addClass('product-offering-exchange__compare-chip--hide');

					setTimeout(() => {
						$(`.product-offering-exchange__compare-chip[data-id='${productId}']`).remove();

						if (!this.productComparisonCheck()) {

							$('.product-offering-exchange__compare').removeClass('product-offering-exchange__compare--active');

						}

					}, 300);

				}

			} else if (this.comparison[this.productKey].length < 3) {

				this.comparison[this.productKey].push(productId);

				localStorage.setItem('comparison', JSON.stringify(this.comparison));

				// $('.product-offering-exchange__compare-chip-padder').remove();

				this.renderComparisonChips(productId);

				// $('.product-offering-exchange__compare-chip-wrapper').append("<span class='product-offering-exchange__compare-chip-padder'>&nbsp;</span>");

				if (this.comparison[this.productKey].length >= 3) {

					$(`.form__control--checkbox input`).prop('disabled', 'disabled');

					this.comparison[this.productKey].forEach(id => {

						$(`.form__control--checkbox[data-id='${id}'] input`).removeAttr('disabled');

					});

				}

			}

			if (this.productComparisonCheck()) {

				$('.product-offering-exchange__compare').addClass('product-offering-exchange__compare--active');

			}

			if (this.comparison[this.productKey].length >= 2) {

				$('.js-compare-button').removeClass('button--disabled');

			} else {

				$('.js-compare-button').addClass('button--disabled');

			}

		}

		if ($(`.product-card[data-id='${productId}'] .product-card__outer`).hasClass("gradient-border")) {

			$(`.product-card[data-id='${productId}'] .product-card__outer`).removeClass("gradient-border");

		} else {

			$(`.product-card[data-id='${productId}'] .product-card__outer`).addClass("gradient-border");

		}

	}

	currencyClick(event: any) {
		let element: any = event.target;
		if(element !== undefined){

			let currency: any = element.getAttribute('data-currency');
			let productCards: any = Array.from(this.element.querySelectorAll('.product-card'));

			if(currency == 'OTHER'){
				productCards.forEach(card => {
					card.classList.add('d-none');
					let supportedCurrencies = card.getAttribute('data-supportedcurrencies')
					supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
					let splittedCurrencies = supportedCurrencies.split(',');
					if(splittedCurrencies.length > 5){
						card.classList.remove('d-none');
					}
				});	
			}else{
				productCards.forEach(card => {
					card.classList.add('d-none');
					let supportedCurrencies = card.getAttribute('data-supportedcurrencies')
					supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
					let splittedCurrencies = supportedCurrencies.split(',');
					splittedCurrencies.forEach(currencySplitted => {
						if(currencySplitted == currency){
							card.classList.remove('d-none');
						}
					});
				});	
			}		

			element.classList.add('product-offering-exchange__currencies--item__active');
			this.currencyStorage = currency;
			localStorage.setItem('currency', JSON.stringify(this.currencyStorage));
			this.renderCurrency(currency);
		}
	}

	productComparisonCheck() {
		//checks to see if the products from JSON match anything in the local storage
		return _.some(this.comparison[this.productKey], (el) =>
			_.includes(_.map(this.productJson, (prod: any) => { return prod.id }), el)
		);
	}

	renderCurrencySelected() {
		this.currencySelector.map((element)=>{
			let currency: any = element.getAttribute('data-currency');
			if(currency == this.currencyStorage){
				element.classList.add('product-offering-exchange__currencies--item__active');
				this.renderCurrency(this.currencyStorage);
			}
		});
	}

	renderProduct(input, orderIndex) {

		// VARIABLES
		let productPrices = "";
		let productTags = "";
		let productTerms = "";
		let productButtons = "";
		let productSupportedCurrencies = "";
		let pricingCurrencies = [];

		// FOR EACH PRICING
		let termCount = 0;
		let pricingArray = {};

		input.pricing.forEach(price => {

			let pricingKeyParent = price.subTitle;
			pricingKeyParent = pricingKeyParent.trim().split(' ').join('').toLowerCase();
			
			pricingArray[pricingKeyParent] = {};
			pricingArray[pricingKeyParent].title = price.subTitle;
			pricingArray[pricingKeyParent].items = [];
			let items = pricingArray[pricingKeyParent].items;

			if(pricingKeyParent == "supportedcurrencies"){
				productSupportedCurrencies = price.title;
			}

			input.pricing.forEach(price => {

				let pricingKey = price.subTitle;
				pricingKey = pricingKey.trim().split(' ').join('').toLowerCase();

				if(pricingKeyParent == pricingKey){
					items.push(price);
				}

			});

		});

		for (let key in pricingArray) {			
			
			let object = pricingArray[key];
			let items = object.items;
			let pricingSections = [];

			items.sort(this.dynamicSort)
			items.forEach(element => {

				let orderKey = element.order;
				
				if (element.terms) {

					if(element.symbol){
						pricingCurrencies.push(element.symbol);
					}
					
					const result = _.entries(_.countBy(pricingCurrencies)).map(([name, count]) => ({ name, count }));
					result.forEach(item => {
						if(item.name === element.symbol){
							termCount = item.count;
						}
					});

					if(element.symbol === undefined){
						termCount = termCount + 1;
					}
					// termCount++;

					let asterix = '';
					for (let index = 0; index < termCount; index++) {
						asterix += '*';
					}
					if(orderKey) {
						if(orderKey > 1){
							productTerms += `
								<div class="product-offering-exchange__terms product-offering-exchange__card--hidden" data-currency-value="` + element.symbol + `">
									<span class="title title--asterisk">${asterix}</span>
									<span>${element.terms}</span>
								</div>
							`;
						}else{
							productTerms += `
								<div class="product-offering-exchange__terms" data-currency-value="` + element.symbol + `">
									<span class="title title--asterisk">${asterix}</span>
									<span>${element.terms}</span>
								</div>
							`;
						}
					}else{
						productTerms += `
							<div class="product-offering-exchange__terms" data-currency-value="` + element.symbol + `">
								<span class="title title--asterisk">${asterix}</span>
								<span>${element.terms}</span>
							</div>
						`;
					}
				}

				productPrices += this.renderProductPrice(element, termCount, true);
				
			});

		}

		// FOR EACH BUTTON
		let btnCount = 0;
		let checkStorage = "";
		let storageValue = "";
		let productEligibility = "";
		let eligibilityExists = false;

		for( var key in this.eligibilityStorage){
			let stripApplyNowModal = key.replace('apply-now-modal-', '');
			checkStorage = _.filter(input.buttons, { modalId: stripApplyNowModal });
			if(checkStorage.length > 0){
				storageValue = this.eligibilityStorage[key];
				productEligibility = this.renderEligibleMessage(this.eligibilityStorage[key].result, key);
			}
		}

		input.buttons.forEach(element => {
			if(element.buttonClass == "Eligibility"){
				eligibilityExists = true;
			}
		});

		input.buttons.forEach(btn => {
			productButtons += this.renderButtons(btn, btnCount, input, storageValue, eligibilityExists);
			btnCount++;
		});

		productTerms = `
			<div class="product-card__terms">

				${productTerms}

			</div>`;

		// FOR EACH TAG
		input.tags.forEach(tag => {
			productTags += " " + tag.replace(/ /g, "-");
		});

		let output = "";
		output += `<div class="product-card product-card__image ${productTags.toLowerCase()}" data-id="${input.id}" style="order: ${orderIndex};" data-supportedcurrencies="${productSupportedCurrencies}">`;

		if (input.onPromotion) {
			output += `<div class="product-card__feature-badge feature-badge">
				${input.promotionLabel}
			</div>`;
		}
		if (input.cardImage) {
			output += `<img class="product-card__image--card" src="${input.cardImage}">`;
		}

		output += `
		<div class="product-card__outer">
			<div class="product-card__inner" data-trackingregion="product offering `+ this.producttype + ` > ${input.title.toLowerCase()}">
				<div class="product-card__content">
					<h4 class="title title--module-sub-title product-card__title">
						${input.title}
					</h4>
					<div class="title title-gradient title-gradient--product"></div>
					<p>${input.subTitle}</p>
					<div class="row">
						${productPrices}
					</div>
				</div>`;

		//card buttons
		output += `
			<div class="product-card__buttons">

				<div class="row">

					<div class="col-12">

						${productTerms}

						<div class="float-md-right float-sm-left">

		`;

		if (input.comparable) {
			if(input.comparable === "true"){
				output += `
								<label data-id="${input.id}" class="form__control form__control--checkbox">
	
									Add to compare
									<input type="checkbox" class="js-compare">
									<div class="form__control-indicator"></div>
	
								</label>
				`;
			}else{
				output += `
								<div class="${this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder product-card__compare-placeholder--sml'}"></div>
				`;
			}
		} else {
			output += `
							<div class="${this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder product-card__compare-placeholder--sml'}"></div>
			`;
		}

		output += `

						</div>

						<div class="product-offering-exchange__eligibility">${productEligibility}</div>

					</div>

					${productButtons}

				</div>

			</div>`;

		//end card buttons

		output += `</div>`; //inner close
		output += `</div>`; //outer close
		output += `</div>`; //main close

		return document.createRange().createContextualFragment(output);
	}

	renderButtons(input, index, product, storage: any = {}, eligibility: boolean = false ) {

		let output = "";
		let productTitle = product.title ? product.title : "<<product name>>";

		if(storage.result == "apply"){

			if(input.buttonClass == 'Apply' || input.buttonClass == 'ProductDetails') {

				if(input.isModal){
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}else{

					if(input.buttonClass === 'Apply'){
	
						output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
							output += `<a class="button button--main" href="javascript:void(0)" data-productname="${product.title}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click" data-leadid="${storage.leadID}">`;
								output += `${input.title}`;
							output += `</a>`;
						output += `</div>`;

					}else{
	
						output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
							output += `<a class="button button--main ${index === 0 || input.buttonClass == "Apply" ? '' : 'button--white button--border-blue'}" data-productname="${product.title}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
								output += `${input.title}`;
							output += `</a>`;
						output += `</div>`;
						
					}
	
				}

			}else{

				if(input.isModal){
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}else{
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main ${index === 0 || input.buttonClass == "ContactUs" ? '' : 'button--white button--border-blue'}" href="${input.url}" target="${input.target}" data-productname="${product.title}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}

			}

		}else if(storage.result == "callmeback"){
			if(input.buttonClass == 'CallMeBack' || input.buttonClass == 'ProductDetails') {

				if(input.isModal){
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click" data-leadid="${storage.leadID}">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}else{
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main ${index === 0 || input.buttonClass == "CallMeBack" ? '' : 'button--white button--border-blue'}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}

			}else{

				if(input.isModal){
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click" data-leadid="${storage.leadID}">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}else{
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main ${index === 0 || input.buttonClass == "ContactUs" ? '' : 'button--white button--border-blue'}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}

			}

		}else if(storage.result == "contactus"){

			if(input.buttonClass == 'ContactUs' || input.buttonClass == 'ProductDetails') {

				if(input.isModal){
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}else{
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main ${index === 0 || input.buttonClass == "ContactUs" ? '' : 'button--white button--border-blue'}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}

			}else{

				if(input.isModal){
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}else{
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main ${index === 0 ? '' || input.buttonClass == "ContactUs" : 'button--white button--border-blue'}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}

			}

		}else{

			if(eligibility){

				if(input.buttonClass == 'Eligibility' || input.buttonClass == 'ProductDetails') {

					if(input.isModal){
		
						output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
							output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
								output += `${input.title}`;
							output += `</a>`;
						output += `</div>`;
		
					}else{
		
						output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
							output += `<a class="button button--main ${index === 0 || input.buttonClass == "Eligibility" || input.buttonClass == "Apply" || input.buttonClass == "ContactUs" || input.buttonClass == "CallMeBack" ? '' : 'button--white button--border-blue'}" data-productname="${product.title}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
								output += `${input.title}`;
							output += `</a>`;
						output += `</div>`;
		
					}
	
				}else{
	
					if(input.isModal){
		
						output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
							output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
								output += `${input.title}`;
							output += `</a>`;
						output += `</div>`;
		
					}else{
		
						output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button product-offering-exchange__button col-xs-6 col-sm-6 d-none" data-buttonclass="${input.buttonClass}">`;
							output += `<a class="button button--main ${index === 0 || input.buttonClass == "Eligibility" || input.buttonClass == "Apply" || input.buttonClass == "ContactUs" || input.buttonClass == "CallMeBack" ? '' : 'button--white button--border-blue'}" data-productname="${product.title}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
								output += `${input.title}`;
							output += `</a>`;
						output += `</div>`;
		
					}
	
				}

			}else{

				if(input.isModal){
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main js-apply-now-modal-open" href="javascript:void(0)" target="" data-productname="${product.title}" data-modal="apply-now-modal-${input.modalId}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}else{
	
					output += `<div class="${index === 0 ? 'product-card__button-wrap' : ''} product-offering-exchange__button col-xs-6 col-sm-6" data-buttonclass="${input.buttonClass}">`;
						output += `<a class="button button--main ${index === 0 || input.buttonClass == "Eligibility" || input.buttonClass == "Apply" || input.buttonClass == "CallMeBack" || input.buttonClass == "ContactUs" ? '' : 'button--white button--border-blue'}" data-productname="${product.title}" href="${input.url}" target="${input.target}" data-id="link_content_product offering" data-text="`+ this.producttype + ` | ` + productTitle + ` | ${input.title} button click">`;
							output += `${input.title}`;
						output += `</a>`;
					output += `</div>`;
	
				}

			}
			
		}

		return output;

	}

	renderProductPrice(input, termCount?: number, hidden: boolean = false) {

		let output = "";

		if(hidden){
			if(input.symbol === "GBP" || input.symbol === undefined){
				output += `<div class="product-card__price col-6 col-xs-6 col-sm-6" data-currency-value="` + input.symbol + `">`;
			}else{
				output += `<div class="product-card__price product-offering-exchange__card--hidden col-6 col-xs-6 col-sm-6" data-currency-value="` + input.symbol + `">`;
			}
		}else{
			output += `<div class="product-card__price col-6 col-xs-6 col-sm-6" data-currency-value="` + input.symbol + `">`;
		}
		
		output += this.renderProductSymbol(input);

		output += this.renderProductTitle(input, termCount);

		output += this.renderProductTooltip(input);

		// output += this.renderProductTerms(input, termCount);

		if (input.strike) {
			output += `
				<div class="title title--initial title--number-strike">
					<span class="title title--number-striker"></span>
			`;

			if(input.symbolHidden !== "true"){
				if (input.symbol) {
					let currencySymbol = this.symbol(input.symbol);
					output += `
						<span class="title title--initial title--currency-sml">
							${currencySymbol.symbol}
						</span>
					`;
				}
			}

			output += `
					<span class="title title--initial title--number-sml">
						${input.strike}
					</span>
				</div>
			`;
		}

		output += `
			<div class="title title--notes">
				${input.subTitle}
			</div>
		`;

		output += `</div>`; //main close

		return output;
	}

	renderProductSymbol(input, termCount: number = 0) {

		let output: string = "";

		if(input.symbolHidden !== "true"){
			if (input.symbol && input.symbol.toLowerCase() == 'r') {
				let currencySymbol = this.symbol(input.symbol);
				output += `
					<span class="title title--initial title--currency">
						${currencySymbol.symbol}
					</span>
				`;
			}else{
				if(input.symbol){
					let currencySymbol = this.symbol(input.symbol);
					output += `
						<span class="title title--initial title--currency">
							${currencySymbol.symbol}
						</span>
					`;
				}
			}
		}

		return output;

	}

	renderProductTitle(input, termCountAsterix: number = 0) {

		let output: string = "";

		let termCount = input.title.length;

		if (input.note) {

			if(termCount <= 7){
				output += `
					<span class="title title--initial product-card__price__note ">
						${input.title}
					</span>
				`;
			}else if(termCount >= 8 && termCount < 16){
				output += `
					<span class="title title--initial product-card__price__note">
						${input.title}
					</span>
				`;
			}else{
				output += `
					<span class="title title--initial product-card__price__note">
						${input.title}
					</span>
				`;
			}

		} else if(input.subTitle == "Supported currencies") {
			
			let supportedCurrencies: any = input.title.split(',');
			let supportedCurrenciesString: string = "";
			let supportedCurrenciesTooltip: string = "";
			
			if(supportedCurrencies.length <= 5){
				for (let index = 0; index < supportedCurrencies.length; index++) {
					if(index == 0) {
						supportedCurrenciesString += supportedCurrencies[index];
					}else{
						supportedCurrenciesString += ", " + supportedCurrencies[index];
					}
				}
			}else if(supportedCurrencies.length > 5){

				for (let index = 0; index < 5; index++) {
					if(index == 0) {
						supportedCurrenciesString += supportedCurrencies[index];
					}else{
						supportedCurrenciesString += ", " + supportedCurrencies[index];
					}
				}
				supportedCurrenciesString += ", Other";

				for (let index = 5; index < supportedCurrencies.length; index++) {
					if(index == 5) {
						supportedCurrenciesTooltip += "SUPPORTED CURRENCIES:<br>" + supportedCurrencies[index];
					}else{
						supportedCurrenciesTooltip += ", " + supportedCurrencies[index];
					}
				}
				supportedCurrenciesString += `
				<span title="${supportedCurrenciesTooltip}" data-title="${supportedCurrenciesTooltip}">
					<i data-component="icon" data-icon="icon-tooltip" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
						<path fill="#0089FF" fill-rule="evenodd" d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z"></path>
					</svg>
					</i>
				</span>
				`;
			}

			output += `
				<span class="title title--initial title--number product-offering-exchange__pricing-title--small product-offering-exchange__pricing-title--supportedcurrencies" style="display: flex !important;">
					${supportedCurrenciesString}
					${this.renderProductTermsSingle(input, termCountAsterix)}
				</span>
			`;

		} else {

			if(termCount <= 7){
				output += `
					<span class="title title--initial title--number">
						${input.title}
						${this.renderProductTermsSingle(input, termCountAsterix)}
					</span>
				`;
			}else if(termCount >= 8 && termCount < 16){
				output += `
					<span class="title title--initial title--number product-offering-exchange__pricing-title--medium" style="display: flex !important;">
						${input.title}
						${this.renderProductTermsSingle(input, termCountAsterix)}
					</span>
				`;
			}else{
				output += `
					<span class="title title--initial title--number product-offering-exchange__pricing-title--small" style="display: flex !important;">
						${input.title}
						${this.renderProductTermsSingle(input, termCountAsterix)}
					</span>
				`;
			}

		}

		return output;

	}

	renderProductTooltip(input, termCount: number = 0) {

		let output: string = "";

		if (input.tooltip) {
			output += `
				<span title="${input.tooltip}" data-title="${input.tooltip}">
					<i data-component="icon" data-icon="icon-tooltip" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
						<path fill="#0089FF" fill-rule="evenodd" d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z"></path>
					</svg>
					</i>
				</span>
			`;
		}

		return output;

	}

	renderProductTerms(input, termCount: number = 0) {
		let output = "";
		if (input.terms) {
			let asterix = '';
			for (let index = 0; index < termCount; index++) {
				asterix += '*';
			}
			output += `
				<span class="title title--initial title--asterisk">${asterix}</span>
			`;
		}
		return output;
	}

	renderProductTermsSingle(input, termCount: number = 0) {
		let output = "";
		if (input.terms) {
			let asterix = '';
			for (let index = 0; index < termCount; index++) {
				asterix += '*';
			}
			output += `${asterix}`;
		}
		return output;
	}

	renderComparisonChips(id) {

		let item = this.productJson.find((item) => { return item.id == id });

		let output = "";
		output += `
			<span class="product-offering-exchange__compare-chip" data-id="${item.id}">

				<span class="title title--notes">

					${item.title}

				</span>

				<i class="icon js-remove-compare" data-id="${item.id}">
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
					<g fill="none" fill-rule="evenodd">
					<circle cx="10" cy="10" r="10" fill="#0089FF"></circle>
					<path fill="#FFF" d="M15 5.604L14.396 5 10 9.396 5.604 5 5 5.604 9.396 10 5 14.396l.604.604L10 10.604 14.396 15l.604-.604L10.604 10 15 5.604"></path>
					</g>
					</svg>
				</i>

			</span>
		`;

		let docfragment = document.createDocumentFragment();
		docfragment.appendChild(document.createRange().createContextualFragment(output));

		$('.product-offering-exchange__compare-chip-wrapper')[0].appendChild(docfragment);

		$('.product-offering-exchange__compare-chip-wrapper')[0].appendChild(docfragment);

	}

	renderFilters() {

		if (this.filterJson && this.filterJson.length > 0) {

			$('.product-filter').addClass('product-filter--show');
			$('.product-filter').removeClass('product-filter--hide');

			let filterfragment = document.createDocumentFragment();
			this.filterJson.forEach(filter => {

				filterfragment.appendChild(document.createRange().createContextualFragment(`
					<span class="product-filter__item"
					data-filter="${filter}" data-id="link_tab_tab" data-text="product offering > ${filter.toLowerCase()}">
						${filter}
					</span>
				`));
			});

			document.querySelector('.product-filter__wrapper').appendChild(filterfragment);

		} else {

			if (this.filterJson) {

				$('.product-filter').addClass('product-filter--none');
				$('.product-filter').removeClass('product-filter--hide');

				$('.product-filter__placeholder > a').attr('src', this.element.getAttribute('data-filterurl'));
				$('.product-filter__placeholder .link__text').text(this.element.getAttribute('data-filtertext'));

			}

		}

	}

	renderCurrency(currency: any) {

		let productCards: any = Array.from(this.element.querySelectorAll('.product-card'));
		let __productCardsAll: any = Array.from(this.element.querySelectorAll('.product-card__price'));
		let __productCardsAllTerms: any = Array.from(this.element.querySelectorAll('.product-offering-exchange__terms'));

		__productCardsAll.forEach(element => {
			element.classList.add('product-offering-exchange__card--hidden');			
			if(element.getAttribute('data-currency-value') === currency || element.getAttribute('data-currency-value') === "undefined"){
				element.classList.remove('product-offering-exchange__card--hidden');
			}
		});

		__productCardsAllTerms.forEach(element => {
			element.classList.add('product-offering-exchange__card--hidden');
			if(element.getAttribute('data-currency-value') === currency || element.getAttribute('data-currency-value') === "undefined"){
				element.classList.remove('product-offering-exchange__card--hidden');
			}
		});

		if(currency == 'OTHER'){
			productCards.forEach(card => {
				card.classList.add('d-none');
				let supportedCurrencies = card.getAttribute('data-supportedcurrencies')
				supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
				let splittedCurrencies = supportedCurrencies.split(',');
				if(splittedCurrencies.length > 5){
					card.classList.remove('d-none');
				}
			});	
		}else{
			productCards.forEach(card => {
				card.classList.add('d-none');
				let supportedCurrencies = card.getAttribute('data-supportedcurrencies')
				supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
				let splittedCurrencies = supportedCurrencies.split(',');
				splittedCurrencies.forEach(currencySplitted => {
					if(currencySplitted == currency){
						card.classList.remove('d-none');
					}
				});
			});	
		}	

	}

	renderCurrencyFilters(currencies: any) {

		if(currencies){

			currencies.forEach(currency => {
				
				if(this.symbol(currency)){
					
					let currencyObject = this.symbol(currency);
					let currencyAnchor = document.createElement('a');
					currencyAnchor.setAttribute('href', 'javascript:void(0)');
					currencyAnchor.setAttribute('data-currency', currencyObject.symbolName);
					currencyAnchor.style.backgroundImage = "url('"+ currencyObject.image +"')";
					currencyAnchor.classList.add('product-offering-exchange__currencies--item');
					currencyAnchor.innerHTML = currencyObject.title;
					this.currencyContainer.appendChild(currencyAnchor);

				}

			});

		}

		this.currencySelector = Array.from(this.element.querySelectorAll('.product-offering-exchange__currencies--item'));

		this.currencySelector.map((element)=>{
			let currency: any = element.getAttribute('data-currency');
			if(currency == this.currencyStorage[this.productKey]){
				element.classList.add('product-offering-exchange__currencies--item__active');
			}
		});

		this.normalizeCardHeight();

		this.renderCurrencySelected();		

	}

	renderEligibleMessage(result: any, modalId: any = ""){
		let message = "";
		if(result){
			if(result == "apply"){
				message += `<div class="product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible">`;
				message += `You are eligible for this product.`;
				message += `</div>`;
			}else if(result == "callmeback"){
				message += `<div class="product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible">`;
				message += `You are eligible for this product.`;
				message += `</div>`;
			}else{
				message += `<div class="product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--invalid">`;
				message += `You are not eligible for this product. <a href="javascript:;" class="js-apply-now-modal-open js-recheck-eligibility" data-modal="${modalId}">Recheck</a>`;
				message += `</div>`;
			}
		}
		return message;
	}

	recheckEligibility(element: any){

		if(element){
			let modalId = element.getAttribute('data-modal');
			let getModalIdRechecks = Array.from(this.element.querySelectorAll('a.js-recheck-eligibility[data-modal='+modalId+']'));
			getModalIdRechecks.forEach(button => {
				let closestMessageContainer = button.closest('.product-offering-exchange__eligibility');
				let closestButtonsContainer = button.closest('.product-card__buttons');
				let buttons = Array.from(closestButtonsContainer.querySelectorAll('.product-offering-exchange__button'));
				buttons.forEach(button => {
					button.classList.add('d-none');
					if(button.getAttribute('data-buttonclass') == "Eligibility" || button.getAttribute('data-buttonclass') == "ProductDetails"){
						button.classList.remove('d-none');
					}
				});
				closestMessageContainer.innerHTML = "";				
				let storageEligibility: any = localStorage.getItem('eligibility');
				storageEligibility = JSON.parse(storageEligibility);
				this.eligibilityStorage = storageEligibility;
				delete this.eligibilityStorage[modalId];
				localStorage.setItem('eligibility', JSON.stringify(this.eligibilityStorage));
			});
		}

	}

	filterProducts(tag) {

		$(`.product-card`).addClass("product-card--hide");


		let filtered = this.productJson.filter((prod) => {
			return prod.tags.indexOf(tag) > -1;
		});

		let removed = this.productJson.filter((prod) => {
			return prod.tags.indexOf(tag) == -1;
		});

		setTimeout(() => {

			this.productJson.forEach(el => {
				$(`.product-card[data-id='${el.id}']`).appendTo(".product-card-wrapper");
			});

			filtered.forEach(el => {
				$(`.product-card[data-id='${el.id}']`).removeClass("product-card--filtered").removeClass("product-card--hide");
			});

			removed.forEach(el => {
				$(`.product-card[data-id='${el.id}']`).addClass("product-card--filtered");
				$(`.product-card[data-id='${el.id}']`).appendTo(".product-card-wrapper");
			});

		}, 200);

	}

	symbol(value: any) {
		
		let key = value;
		key = key.trim().split(' ').join('').toUpperCase();

		switch (key) {
			case "GBP":
				return {
					title: "GBP",
					symbolName: "GBP",
					symbol: "£",
					image: "/file_source/assets/icons/flag-united-kingdom.svg"
				} 
				break;
			case "USD":
				return {
					title: "USD",
					symbolName: "USD",
					symbol: "$",
					image: "/file_source/assets/icons/flag-united-states.svg"
				} 
				break;	
			case "ZAR":
				return {
					title: "ZAR",
					symbolName: "ZAR",
					symbol: "R",
					image: "/file_source/assets/icons/flag-south-africa.svg"
				} 
				break;
			case "AUD":
				return {
					title: "AUD",
					symbolName: "AUD",
					symbol: "AU$",
					image: "/file_source/assets/icons/flag-australia.svg"
				} 
				break;
			case "EUR":
				return {
					title: "EURO",
					symbolName: "EUR",
					symbol: "€",
					image: "/file_source/assets/icons/flag-euro.svg"
				} 
				break;		
			case "OTHER":
				return {
					title: "OTHER",
					symbolName: "OTHER",
					symbol: "",
					image: "/file_source/assets/icons/flag-global.svg"
				} 
				break;		
			case "Other":
				return {
					title: "OTHER",
					symbolName: "OTHER",
					symbol: "",
					image: "/file_source/assets/icons/flag-global.svg"
				} 
				break;		
			case "other":
				return {
					title: "OTHER",
					symbolName: "OTHER",
					symbol: "",
					image: "/file_source/assets/icons/flag-global.svg"
				} 
				break;	
			default:
				break;
		}

	}

	dynamicSort(a: any, b: any) {
		// Use toUpperCase() to ignore character casing
		const orderA = a.order;
		const orderB = b.order;
	  
		let comparison = 0;
		if (orderA > orderB) {
		  comparison = 1;
		} else if (orderA < orderB) {
		  comparison = -1;
		}
		return comparison;
	}

	debounce(func, wait, immediate) {
		let timeout;
		return function () {
			let context = this, args = arguments;
			let later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	actionApplyNow(leadId: any = '', productName: any = '', messageEligibility: any) {

		let messageEligiblility = messageEligibility;

		let postData = '';
		postData += 'operation=submit&';
		postData += 'category=individual&';
		postData += 'leadID=' + leadId + '&';
		postData += 'productName=' + productName + '&';

		let analyticsService = new AnalyticsService();
		this.analyticsService.dtmFormStart("applynow " + productName);
		let url = "/services/SubmitWINLead.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {

			let json: any = response.data;

			if(json){

				let errors = json.Errors;
				if(errors.length > 0){
					errors.forEach(error => {
						analyticsService.dtmRecordSiteError('noerrorcode|' + error + '|' + url);
						messageEligiblility.classList.add('product-offering-exchange__eligibility-message--invalid');
						if(error.includes('Unknown product')){
							messageEligiblility.innerHTML = 'Invalid request';
						}
						if(error.includes('Authorization')){
							messageEligiblility.innerHTML = 'Invalid request';
						}
						if(error.includes('undocumented')){
							messageEligiblility.innerHTML = 'Request failed – try again later';
						}
						if(error.includes('existing')){
							messageEligiblility.innerHTML = 'Your request has already been submitted';
						}
					});
				}else{
					let resources = json.Resources;
					if(resources){
						let lmm = resources.LMM;
						if(lmm){
							analyticsService.dtmFormComplete('complete', leadId);
							window.location = lmm;
						}
					}
				}
				
			}

		}).catch(function (response) {
			analyticsService.dtmRecordSiteError('noerrorcode|' + response + '|' + url);
		});

	}


}



// WEBPACK FOOTER //
// ./components/product-offering-exchange/product-offering-exchange.component.ts